module.exports = __webpack_public_path__ + "static/media/accenture__ciie.c047f6bd.svg";